// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ccfcfea6","455":"c878eaf2"}[chunkId] + ".chunk.js";
};